import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "reactstrap";
import { useFormik } from "formik";
import { projectGallerySchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import Breadcrumb from "../../Components/Breadcrumb";
import { SwitchToggle } from "../../Components/TableHelper";

const AddProjectGallery = () => {
    const { projectId } = useParams();
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const [loading, setLoading] = useState(false);
    const editingId = editData?._id;
    const projectTypeId = location?.state?.projectTypeId || editData?.projectId?.projectTypeId?._id;

    const initalvalues = {
        name: editData?.name || "",
        image: editData?.image || "",
        sortOrder: editData?.sortOrder || 1,
        isActive: editData?.isActive ?? true,
        projectId: editData?.projectId || projectId,
    };

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        setFieldValue,
        touched,
        handleBlur,
    } = useFormik({
        initialValues: initalvalues,
        validationSchema: projectGallerySchema,
        onSubmit: async (values) => {
            setLoading(true);

            try {
                const formData = new FormData();

                formData.append("name", values.name);
                formData.append("sortOrder", values.sortOrder);
                formData.append("isActive", values.isActive);
                formData.append("projectId", values.projectId);

                if (values.image instanceof File) {
                    formData.append("image", values.image);
                }

                const response = editingId ? await axiosInstance.put(`/projectgallery/updategallery/${editingId}`,
                    formData) : await axiosInstance.post("/projectgallery/creategallery", formData);

                if (response.status === 200) {
                    toast.success(response.data.message);
                    navigator(`/project-gallery/${editData?.projectId || projectId}`);
                }
            } catch (error) {
                toast.error(error.response?.data?.message);
            } finally {
                setLoading(false);
            }
        }
    });

    const breadcrumbdata = [
        { label: "Home", path: "/dashboard" },
        { label: "Project Types", path: "/project-types" },
        { label: "Projects", path: `/project/${projectTypeId}` },
        { label: editingId ? "Update" : "Add", path: "*" },
    ];

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mb-3">
                    <h3 className="custom-page-title">
                        {editingId ? "Update" : "Add"} Gallery
                    </h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>
                <div className="col-md-12 grid-margin stretch-card p-0">
                    <div className="card m-0">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="gallery-sortOrder"
                                                className="col-form-label "
                                            >
                                                Sort Order
                                            </label>
                                            <input
                                                type="number"
                                                className={`border border-dark form-control  `}
                                                id="gallery-sortOrder"
                                                name="sortOrder"
                                                placeholder="Enter gallery Sort Order"
                                                min={1}
                                                value={values.sortOrder}
                                                onChange={handleChange}
                                            />
                                            {touched.sortOrder && errors.sortOrder && (
                                                <small className="text-danger">
                                                    {errors.sortOrder}
                                                </small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="gallery-name"
                                                className="col-form-label "
                                            >
                                                Name
                                            </label>
                                            <input
                                                type="text"
                                                className={`border border-dark form-control  `}
                                                id="gallery-name"
                                                name="name"
                                                placeholder="Enter gallery name"
                                                value={values.name || ""}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {touched.name && errors.name && (
                                                <small className="text-danger">{errors.name}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <ImageUploadDragAndDrop
                                                id="feature-image"
                                                label={`Gallery Image (Landscape Mode: 1751w X 1100h Or Portrait Mode: 871w X 1100h)`}
                                                value={values.image}
                                                onChange={(file) => setFieldValue("image", file)}
                                                error={errors.image}
                                                touched={touched.image}
                                            />
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-5  `}>
                                        <SwitchToggle
                                            checked={values.isActive}
                                            onChange={(val) => setFieldValue("isActive", val)}
                                        />
                                    </div>
                                </div>

                                <div className="text-center mt-4">
                                    <Button type="submit" color="primary" disabled={loading}>
                                        {loading ? (
                                            <span className="d-inline-flex align-items-center gap-2">
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Processing...
                                            </span>
                                        ) : (
                                            "Save"
                                        )}
                                    </Button>
                                    <Link to={`/project-gallery/${editData?.projectId?._id || projectId}`}>
                                        <Button color="danger mx-2">Cancel </Button>
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddProjectGallery;
